__turbopack_context__.v({
  "groupsProposalList": "ProposalList-module__gWr6pG__groupsProposalList",
  "icon": "ProposalList-module__gWr6pG__icon",
  "proposal": "ProposalList-module__gWr6pG__proposal",
});
